// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 10px;
}
body {
  padding: 0px;
  margin: 0px;
}
.dragDrop .badge {
  display: none;
  position: absolute;
  right: 0px;
  color: rgb(155 155 155);
}
.dragDrop .list-group:hover .badge {
  display: block;
}
.dragDrop .list-group-item {
  position: relative;
  display: block;
  padding: 5px 10px;
  color: #4e4e4e;
  text-decoration: none;
  background-color: #fff;
  /* border: 0px; */
  font-weight: 400;
  font-size: 12px;
  word-break: break-all;
   display: -webkit-box;           /* ✅ enables flexbox layout for webkit */
  -webkit-line-clamp: 3;          /* ✅ number of lines to show */
  -webkit-box-orient: vertical;   /* ✅ vertical flow */
  overflow: hidden;               /* ✅ hides the overflow text */
  text-overflow: ellipsis; 
}
.list-group {
  cursor: pointer;
  /* border-bottom: 5px solid #dfdfdf; */
  border-radius: 0px;
}
.list-group-item {
  min-height: 25px;
}
.dragDrop p {
  padding: 0px;
  margin: 0px;
}
.dragDrop i {
  font-size: 14px;
  padding-left: 10px;
}
.form-check-input {
  width: 15px;
  height: 15px;
  margin-top: 0em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  appearance: none;
  /* -webkit-print-color-adjust: exact;
  color-adjust: exact; */
}
.dropdown-toggle:empty::after {
  display: none;
}
.kanbanHeader {
  padding: 5px 10px;
  border-top: 3px solid #3ca8e8;
  border-bottom: 5px solid #ebeef2;
  font-size: 14px;
  font-weight: 500;
  font-size: 12px;
}
.dragDrop button {
  border: 0px;
}
/* .task-card {
  border: 1px solid #747474;
} */
.task-container {
  font-size: 12px;
}
.task-container .bi {
  font-size: 12px;
  color: #6a6a6a;
  /* padding-right: 8px; */
}
.task-container .badge {
  text-align: right;
}
/* CustomDropdown.css */
.dropdown-submenu {
  position: relative;
}

.dropdown-submenu .dropdown-menu {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 0;
  border-radius: 0.25rem;
}

.dropdown-submenu:hover .dropdown-menu {
  display: block;
}

.submenu-toggle::after {
  content: ""; /* right arrow */
  float: right;
}
.offcanvas-backdrop.show {
  opacity: 0.1;
}
.stage99-container {
  position: fixed;
  bottom: 50px;
  left: 290;
  right: 50;
  border: 2px dashed #aaa;
  margin-top: 20px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  z-index: -1;
  max-height: 200px;
  overflow: scroll;
  display: none;
}
.stage99-container.stage99-container-show {
  display: block;
  z-index: 9;
  border: 2px dashed #2196f3;
  background-color: #000;
  transition: 0.2s ease-in-out;
}
.list-group-item{
  border-color:rgb(144, 144, 144);  
  border-top:0px;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Drag_Drop/AdminDragDrop.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;GACpB,oBAAoB,YAAY,wCAAwC;EACzE,qBAAqB,WAAW,8BAA8B;EAC9D,4BAA4B,IAAI,oBAAoB;EACpD,gBAAgB,gBAAgB,8BAA8B;EAC9D,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,qCAAqC;EAGrC,gBAAgB;EAChB;wBACsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;GAEG;AACH;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW,EAAE,gBAAgB;EAC7B,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB","sourcesContent":[".flex {\r\n  display: flex;\r\n  gap: 10px;\r\n  overflow-x: auto;\r\n  padding-bottom: 10px;\r\n}\r\nbody {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n.dragDrop .badge {\r\n  display: none;\r\n  position: absolute;\r\n  right: 0px;\r\n  color: rgb(155 155 155);\r\n}\r\n.dragDrop .list-group:hover .badge {\r\n  display: block;\r\n}\r\n.dragDrop .list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: 5px 10px;\r\n  color: #4e4e4e;\r\n  text-decoration: none;\r\n  background-color: #fff;\r\n  /* border: 0px; */\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  word-break: break-all;\r\n   display: -webkit-box;           /* ✅ enables flexbox layout for webkit */\r\n  -webkit-line-clamp: 3;          /* ✅ number of lines to show */\r\n  -webkit-box-orient: vertical;   /* ✅ vertical flow */\r\n  overflow: hidden;               /* ✅ hides the overflow text */\r\n  text-overflow: ellipsis; \r\n}\r\n.list-group {\r\n  cursor: pointer;\r\n  /* border-bottom: 5px solid #dfdfdf; */\r\n  border-radius: 0px;\r\n}\r\n.list-group-item {\r\n  min-height: 25px;\r\n}\r\n.dragDrop p {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n.dragDrop i {\r\n  font-size: 14px;\r\n  padding-left: 10px;\r\n}\r\n.form-check-input {\r\n  width: 15px;\r\n  height: 15px;\r\n  margin-top: 0em;\r\n  vertical-align: top;\r\n  background-color: #fff;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: contain;\r\n  border: 1px solid rgba(0, 0, 0, 0.25);\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  /* -webkit-print-color-adjust: exact;\r\n  color-adjust: exact; */\r\n}\r\n.dropdown-toggle:empty::after {\r\n  display: none;\r\n}\r\n.kanbanHeader {\r\n  padding: 5px 10px;\r\n  border-top: 3px solid #3ca8e8;\r\n  border-bottom: 5px solid #ebeef2;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n}\r\n.dragDrop button {\r\n  border: 0px;\r\n}\r\n/* .task-card {\r\n  border: 1px solid #747474;\r\n} */\r\n.task-container {\r\n  font-size: 12px;\r\n}\r\n.task-container .bi {\r\n  font-size: 12px;\r\n  color: #6a6a6a;\r\n  /* padding-right: 8px; */\r\n}\r\n.task-container .badge {\r\n  text-align: right;\r\n}\r\n/* CustomDropdown.css */\r\n.dropdown-submenu {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-submenu .dropdown-menu {\r\n  display: none;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 100%;\r\n  margin-left: 0;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.dropdown-submenu:hover .dropdown-menu {\r\n  display: block;\r\n}\r\n\r\n.submenu-toggle::after {\r\n  content: \"\"; /* right arrow */\r\n  float: right;\r\n}\r\n.offcanvas-backdrop.show {\r\n  opacity: 0.1;\r\n}\r\n.stage99-container {\r\n  position: fixed;\r\n  bottom: 50px;\r\n  left: 290;\r\n  right: 50;\r\n  border: 2px dashed #aaa;\r\n  margin-top: 20px;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  z-index: -1;\r\n  max-height: 200px;\r\n  overflow: scroll;\r\n  display: none;\r\n}\r\n.stage99-container.stage99-container-show {\r\n  display: block;\r\n  z-index: 9;\r\n  border: 2px dashed #2196f3;\r\n  background-color: #000;\r\n  transition: 0.2s ease-in-out;\r\n}\r\n.list-group-item{\r\n  border-color:rgb(144, 144, 144);  \r\n  border-top:0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
